import { supabase } from "@/integrations/supabase/client";

/**
 * Utility function to set up realtime subscriptions for chat functionality
 * Returns cleanup function for proper resource management
 */
export const setupChatRealtime = (
  notificationId: string,
  onMessageInsert: (payload: any) => void,
  onMessageUpdate: (payload: any) => void,
  onReadStatusUpdate?: (payload: any) => void
) => {
  console.log("Setting up realtime subscription for notification:", notificationId);
  
  const channels: any[] = [];

  // Subscribe to chat messages changes
  const chatChannel = supabase
    .channel(`notification_chat_${notificationId}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'notification_chat',
        filter: `notification_id=eq.${notificationId}`,
      },
      (payload) => {
        console.log("Chat message change:", payload);
        
        if (payload.eventType === 'INSERT') {
          onMessageInsert(payload);
        } else if (payload.eventType === 'UPDATE') {
          onMessageUpdate(payload);
        }
      }
    )
    .subscribe((status) => {
      console.log("Chat channel subscription status:", status);
    });

  channels.push(chatChannel);

  // Subscribe to read status changes if callback provided
  if (onReadStatusUpdate) {
    const readStatusChannel = supabase
      .channel(`chat_read_status_${notificationId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_chat_read_status',
          filter: `notification_id=eq.${notificationId}`,
        },
        (payload) => {
          console.log("Read status change:", payload);
          onReadStatusUpdate(payload);
        }
      )
      .subscribe((status) => {
        console.log("Read status channel subscription status:", status);
      });

    channels.push(readStatusChannel);
  }

  // Return cleanup function
  return () => {
    console.log("Cleaning up chat realtime subscriptions");
    channels.forEach(channel => {
      supabase.removeChannel(channel);
    });
  };
};